export default {
  title: "أساسيات البرمجة",
  subtitle: "وضع الأسس لممارسات البرمجة الفعالة",
  overviewTitle: "نظرة عامة على الدورة",
  overview: `<p className="cs-m0">
              تم تصميم هذه الدورة الشاملة لتعريفك بالمبادئ الأساسية للبرمجة، مما يشكل أساسًا قويًا للمطورين الطموحين. ستستكشف مفاهيم البرمجة الأساسية مثل المتغيرات، وهياكل التحكم، وأنواع البيانات، والخوارزميات، والتي تعتبر ضرورية لكتابة كود فعال عبر لغات البرمجة المختلفة.
            </p>
            <br />
            <p className="cs-m0">
              يغطي المنهج لغات شائعة مثل بايثون، وجافا، وجافا سكريبت، مما يتيح لك اكتساب خبرة عملية في البرمجة من خلال التمارين والمشاريع العملية. ستتعلم كيفية حل المشكلات باستخدام التفكير المنطقي وتطوير الخوارزميات التي تُحسن كودك من حيث الكفاءة والوضوح.
            </p>
            <br />
            <p className="cs-m0">
              سواء كنت مبتدئًا تمامًا أو تبحث عن تعزيز مهاراتك الحالية، ستجهزك هذه الدورة بالمعرفة والثقة اللازمة لمواجهة مفاهيم البرمجة الأكثر تقدمًا والتحديات الواقعية.
            </p>`,
};
